import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { BiListOl } from "react-icons/bi";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { activeButtonStyle, buttonStyle } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonOrderedListProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonOrderedList = ({ className, children }: TextEditorMenuButtonOrderedListProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  const buttonClassName = editor && editor.isActive("orderedList") ? activeButtonStyle : buttonStyle;

  return (
    <Tooltip content={t("buttons.orderedlist")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().focus().toggleOrderedList().run();
          }
        }}
        className={twMerge(buttonClassName, className)}
        disabled={disabled}
      >
        {children ?? <BiListOl className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
